import React from "react";
import BackImg from "../../images/backBtn.svg";

function BackTab(props) {
  return (
    <button onClick={() => props.back()}>
      <img src={BackImg} alt="" />
    </button>
  );
}

export default BackTab;
